<template>
  <BaseModal :title="_T('@Order')" @on-close-modal="onCloseModal">
    <div class="modal-spp">
      <p class="modal-spp__text">
        {{ _T("@The manager will contact you to clarify") }}
      </p>
      <MyForm
        id="subscription"
        name="subscription"
        :schema="schema"
        :state="form"
        class="modal-spp__form"
        @submit="subscribe"
      >
        <MyInput
          v-model.trim="form.name"
          name="name"
          caption="@Name"
          autocomplete="given-name"
        />
        <MyInput
          v-model.trim="form.phone"
          v-maska="'+38(0##) ### ## ##'"
          name="phone"
          type="tel"
          caption="@Phone number"
        />
        <MyInput v-model="form.message" name="message" caption="@Message" />
        <ButtonPrimary
          type="submit"
          :aria-label="_T('@Order')"
          button-width="363px"
        >
          {{ _T("@Order") }}
        </ButtonPrimary>
        <p class="modal-spp__text">
          {{ _T("@Your data will not be passed on to third parties") }}
        </p>
      </MyForm>
    </div>
  </BaseModal>
</template>

<script setup>
import {
  successfulModal,
  useModalStore,
  sppModal,
} from "~/modules/shared/modals/store/modalStore";
import { formatPhone, phoneCheck } from "~~/utils/phoneHelper";
import { useUserStore } from "~/store/userStore";
import { useAPI } from "~/uses/useMyFetch";
import BaseModal from "~/modules/shared/modals/BaseModal.vue";
import ButtonPrimary from "~/modules/shared/buttons/ButtonPrimary.vue";
import MyForm from "~/nuxt_modules/common/ui/components/form/MyForm.vue";
import MyInput from "~/nuxt_modules/common/ui/components/form/MyInput.vue";
import { vMaska } from "maska/vue";
import { z } from "zod";

const modalStore = useModalStore();

const userStore = useUserStore();
const { currentUser: user } = storeToRefs(userStore);

onMounted(() => {
  if (null !== user.value) {
    form.name = user.value.name.firstName;
    form.phone = user.value.phone;
  }
});

const successfulData = {
  title: _T("@Successful modal title"),
  description: _T("@Successful modal text"),
  isWithTimeout: true,
};

const schema = z.object({
  name: z
    .string(_T("@Entry field required"))
    .max(255, `${_T("@Maximum field length")} 255`)
    .regex(/^\S*$/, _T("@Must not contain spaces")),
  phone: z
    .string(_T("@Entry field required"))
    .refine(
      (phone) => phoneCheck(phone),
      _T("@You entered an incorrect phone number"),
    ),
  message: z
    .string()
    .max(1024, `${_T("@Maximum field length")} 1024`)
    .optional(),
});

const form = reactive({
  name: undefined,
  phone: undefined,
  message: undefined,
});

function subscribe(data) {
  useAPI("/marketing/event", {
    method: "POST",
    body: {
      event: "solarPowerPlantOrderCreated",
      phone: formatPhone(data.phone),
      isConfirmed: true,
      name: data.name,
      form: {
        message: data.message,
      },
    },
  }).then(() => {
    modalStore.toggleModal(sppModal);

    modalStore.toggleModal(successfulModal, successfulData);
  });
}

const onCloseModal = () => {
  modalStore.toggleModal(sppModal);
};
</script>

<style lang="scss" scoped>
.modal-spp {
  @include flex-container(column, space-between);
  gap: 24px;

  &__text {
    @include font(16, 20, 400);
    text-align: center;

    @include mobile {
      @include font(14, 18, 400);
    }
  }

  &__form {
    width: 100%;
    @include flex-container(column, center, center);

    gap: 24px;
  }
}
</style>
